import React, { useEffect } from "react";
import { Router } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { SnackbarProvider, useSnackbar } from "notistack";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { setSnackbarRef } from "./utils/snackbarRef";

import Routes from "./routes";
import history from "./services/history";

import { store, persistor } from "./store";

import GlobalStyle from "./styles/global";

import { AnimateSharedLayout } from "framer-motion";

import { AuthProvider } from "./hooks/auth/AuthContext";
import ScrollToTop from "./store/scrollToTop";
import OxeBot from "./components/OxeBot";
import AppBottomNavigation from "./components/BottomNavigation";
import AppBreadcrumbs from "./components/AppBreadcrumbs";

const theme = createTheme();

function App() {
  return (
    <ThemeProvider theme={theme}>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <Router history={history}>
          <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            autoHideDuration={4000}
          >
            <SnackbarRefCapture />
            <AnimateSharedLayout>
              <AuthProvider>
                <ScrollToTop />
                <AppBreadcrumbs />
                <Routes />
                <AppBottomNavigation />
                <OxeBot />
              </AuthProvider>

              <GlobalStyle />
            </AnimateSharedLayout>
          </SnackbarProvider>
        </Router>
      </PersistGate>
    </Provider>
    </ThemeProvider>
  );
}

/** Captura ref do notistack para uso em sagas e módulos não-React */
function SnackbarRefCapture() {
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => { setSnackbarRef(enqueueSnackbar); }, [enqueueSnackbar]);
  return null;
}

export default App;
